module.exports = __webpack_public_path__ + "35254a5cd01a079d0a04307a21ea15ab.png";